module.exports = __webpack_public_path__ + "static/media/delivery.73b08550.png";